import {
    css, DirectionalHint,
    IContextualMenuItem, TooltipHost,
} from "@fluentui/react";
import { MenuButton, Menu, MenuTrigger, MenuPopover, MenuList, MenuItem } from "@fluentui/react-components";
import { MoreVerticalRegular } from "@fluentui/react-icons";
import * as React from "react";
import ListPageStyles from "./ListPage.styles";

interface IOwnProps {
    /** Actions/Controls to show all the time */
    visibleActions?: React.ReactNode[];
    /** Collection of actions to show in an overflow set */
    menuActions?: IContextualMenuItem[];
}

export class ListItemActionSet extends React.Component<IOwnProps, {}> {

    public render() {
        const alwaysVisibleActions = this.renderAlwaysVisibleActions();
        const overflowActions = this.renderOverflowActions();
        if (alwaysVisibleActions || overflowActions) {
            return (
                <span className={css(ListPageStyles.listPageListItemActionsContainer)}>
                    {alwaysVisibleActions}
                    {overflowActions}
                </span>
            );
        } else {
            return null;
        }
    }

    private renderAlwaysVisibleActions() {
        if (this.props.visibleActions && this.props.visibleActions.length > 0) {
            return this.props.visibleActions;
        } else {
            return null;
        }
    }

    private renderOverflowActions() {
        if (this.props.menuActions && this.props.menuActions.length > 0) {
            return (
                <TooltipHost
                    content={"More"}
                    calloutProps={{ directionalHint: DirectionalHint.bottomCenter, beakWidth: 12 }}
                >
                    <Menu>
                        <MenuTrigger>
                            <MenuButton
                                className={css(ListPageStyles.listPageListItemActionIcon, ListPageStyles.listPageListItemActionsRoot)}
                                aria-label={"More actions"}
                                icon={<MoreVerticalRegular />}
                            />
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList>
                                {this.props.menuActions.map((item: IContextualMenuItem) => (
                                    <MenuItem
                                        key={item.key}
                                        onClick={() => item.onClick && item.onClick(undefined, item)}
                                        disabled={item.disabled}
                                    >
                                        {item.text}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                </TooltipHost>
            );
        } else {
            return null;
        }
    }
}
